import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";
import DashboardDoughnut from "../DashboardDoughnut";
import DoughnutLegend from "../DoughnutLegend";
import HspScreeningCoverageDialog from "./HspScreeningCoverageDialog";

import { displayData } from "../../../utils/data";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  doughnutContainer: {
    margin: "0px",
    display: "flex",
    alignItems: "center",
  },
  title: {
    color: colors.black54,
  },
  subTitle: {
    textAlign: "center",
    fontWeight: 500,
    color: colors.black87,
    marginTop: "10px",
  },
  value: {
    textAlign: "center",
    color: colors.primary,
    fontWeight: 500,
    fontSize: "2em",
    lineHeight: "30px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const HspScreeningCoverage = (props) => {
  const { classes, data } = props;
  const [secondaryDetails, setSecondaryDetails] = React.useState({
    open: false,
    section: null,
    subSection: null,
  });

  const doughnutColors = [colors.dashboardDarkBlue, colors.dashboardLightBlue];

  let filters = props.filters;
  if (get(filters, ["header"])) {
    filters.header.section = get(secondaryDetails, ["section"]);
    filters.header.subsection = get(secondaryDetails, ["subSection"]);
  }

  return (
    <DashboardCard
      title={I18n.get("dashboard_screeningCoverage")}
      size={sizes.small}
    >
      <HspScreeningCoverageDialog
        open={get(secondaryDetails, ["open"])}
        setOpen={setSecondaryDetails}
        filters={filters}
        subSection={get(secondaryDetails, ["subSection"])}
      />
      <Grid
        container
        wrap="nowrap"
        alignItems="center"
        justify="center"
        style={{ height: "100%" }}
      >
        <Grid item style={{ maxWidth: "300px", width: "100%" }}>
          <Grid container direction="column">
            <Grid item className={classes.title} style={{ margin: "0 auto" }}>
              {I18n.get("dashboard_uniqueEmployees")}
            </Grid>
            <Grid item>
              <Grid container wrap="nowrap">
                <Grid item className={classes.doughnutContainer}>
                  <DashboardDoughnut
                    values={[
                      get(data, ["coverage", "total"]),
                      get(data, ["coverage", "notcompleted"]),
                    ]}
                    centeredValue={
                      get(data, ["coverage", "total"]) +
                      get(data, ["coverage", "notcompleted"])
                    }
                    colors={doughnutColors}
                    icon={images.humanIconBlack}
                    onClick={() =>
                      setSecondaryDetails({
                        open: true,
                        section: "coverage",
                        subSection: "all",
                      })
                    }
                  />
                </Grid>
                <Grid item style={{ padding: "0px 14px" }}>
                  <Grid container direction="column">
                    <DoughnutLegend
                      color={doughnutColors[0]}
                      title={I18n.get("dashboard_atLeast1Screening")}
                      value={get(data, ["coverage", "total"])}
                      percentage={Math.round(
                        get(data, ["coverage", "percentage"]) * 100
                      )}
                      onClick={() =>
                        setSecondaryDetails({
                          open: true,
                          section: "coverage",
                          subSection: "total",
                        })
                      }
                    />
                    <DoughnutLegend
                      color={doughnutColors[1]}
                      title={I18n.get("dashboard_noScreening")}
                      value={get(data, ["coverage", "notcompleted"])}
                      percentage={Math.round(
                        (1 - get(data, ["coverage", "percentage"])) * 100
                      )}
                      onClick={() =>
                        setSecondaryDetails({
                          open: true,
                          section: "coverage",
                          subSection: "notcompleted",
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            borderLeft: `1px solid ${colors.veryLighPink}`,
            padding: "0px 10px",
          }}
        >
          <Grid container direction="column">
            <Grid item className={classes.title}>
              {I18n.get("dashboard_totalScreeningCounts")}
            </Grid>
            <Grid item className={classes.subTitle}>
              {I18n.get("dashboard_onSite")}
            </Grid>
            <Grid
              item
              className={classes.value}
              onClick={() =>
                setSecondaryDetails({
                  open: true,
                  section: "coverage",
                  subSection: "onsite",
                })
              }
            >
              {displayData(get(data, ["coverage", "onsite"]))}
            </Grid>
            <Grid item className={classes.subTitle}>
              {I18n.get("profiles_online")}
            </Grid>
            <Grid
              item
              className={classes.value}
              onClick={() =>
                setSecondaryDetails({
                  open: true,
                  section: "coverage",
                  subSection: "remote",
                })
              }
            >
              {displayData(get(data, ["coverage", "remote"]))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DashboardCard>
  );
};

export default withStyles(styles)(HspScreeningCoverage);
